import React from 'react';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';

// Utils
import { isSelectingSingleSelectionAndCell } from '../../../../../element/table/utils/selectionUtils/tableSelectionPredicateUtils';
import { addHotTableFormulaToCell } from '../../../../../element/table/utils/hotInstanceUtils/cell/hotTableCellFormulaUtils';

// Selectors
import { useActiveTableCallback, useActiveTableSelector } from '../../../../../element/table/store/hotTableStoreHooks';
import { selectActiveTableCellSelection } from '../../../../../element/table/store/selectors/activeHotTableSelectors';

type TableCellFormulaToolProps = Record<string, unknown> & {
    element?: ImMNElement;
};

const TableCellFormulaTool: React.FC<TableCellFormulaToolProps> = (props) => {
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    const triggerFormula = useActiveTableCallback((activeTable) => addHotTableFormulaToCell(activeTable.instance), []);

    return (
        <div className="TableCellFormulaTool">
            <ToolbarTool
                {...props}
                onClick={triggerFormula}
                isActive={false}
                disabled={!isSelectingSingleSelectionAndCell(currentCellSelections)}
            >
                <Icon name="toolbar-formula" />
            </ToolbarTool>
        </div>
    );
};

export default TableCellFormulaTool;
